import React, { useContext } from 'react';
import abouttitlear from '../../../Assets/Images/Home/abouttitlear.png'
import abouttitleen from '../../../Assets/Images/Home/abouttitleen.png'
import String from '../../../Assets/Localization/Local'
import { LangContext, CompanyData } from '../../../App'
import { API_ENDPOINT } from '../../../AppConfig'
import ReactImageFallback from "react-image-fallback";
import { Link } from 'react-router-dom'
import avatar from '../../../Assets/Images/avatar.jpg'

const AboutUs = () => {
  const { lang } = useContext(LangContext)
  const { data } = useContext(CompanyData)
  String.setLanguage(lang);
  console.log("image", data && `${API_ENDPOINT}${data.aboutUsImage}`)
  return (
    <div className="AboutUs">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8 col-lg-6 col-xl-7">
            <div className="HomeTitle">
              <img src={lang === "ar" ? abouttitlear : abouttitleen} alt="titleBG" />
              <h2 style={{ transform: lang === "ar" ? "translate(-45%, 65%)" : "translate(45%, 65%)" }}>{String.whous}</h2>
            </div>
            <div className="aboutpara px-5 mt-4">
              <p>
                {data && data.aboutUs}
              </p>
              <Link to="/HealthBook-Web/about-us">
                <button className="btn mt-4">{String.showmore}</button></Link>
            </div>
          </div>
          <div className="col-md-4 col-lg-6 col-xl-5 d-none d-md-block">
            <div className="d-flex justify-content-end">
              <ReactImageFallback
                className="aboutimg"
                src={data && `${API_ENDPOINT}${data.aboutUsImage}`}
                fallbackImage={avatar}
                initialImage={avatar}
                alt="aboutimg" />
            </div>
            {/* <div style={{ backgroundImage: data && `url(${API_ENDPOINT}${data.aboutUsImage})` }} className="aboutimg"></div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
